import axios from "axios";
import { Authen } from "./Middleware/authen";
import { API_URL, USER, TOKEN, TOKEN_EXP, USER_GROUP } from "../Config";
import authHeader from "./auth-header";

const login = async (values) => {
  return await axios.post(API_URL + "login", values).then((response) => {
    const { data } = response;
    if (data.status === true) {
      localStorage.setItem(TOKEN, data.result.token);
      localStorage.setItem(TOKEN_EXP, new Date());
      localStorage.setItem(USER, JSON.stringify(data.result));
      localStorage.setItem(USER_GROUP, JSON.stringify(data.result.users_group));
    }
    return data;
  });
};

const logout = () => {
  localStorage.removeItem(TOKEN);
  localStorage.removeItem(USER);
  localStorage.removeItem(TOKEN_EXP);
  localStorage.removeItem(USER_GROUP);
};

const reloadPage = () => {
  const isAuth = Authen();
  return isAuth;
};

const auth = () => {
  const getStore = localStorage.getItem(USER);
  const parseUser = JSON.parse(getStore);
  return parseUser ? parseUser.user : null;
};

const permission = (permisionName) => {
  const getStore = localStorage.getItem(USER_GROUP);
  if (!getStore) {
    return false;
  }
  const parseUser = JSON.parse(getStore);
  let r = parseUser.find((p) => p === permisionName);
  return r ? true : false;
};

const update_password = (values) => {
  return axios.post(API_URL + "password/update", values, {
    headers: authHeader(),
  });
};

const send_email_update_password = (values) => {
  return axios.get(API_URL + "send-mail/update/password", {
    params: values,
  });
};
const update_password_reset = (values) => {
  return axios.post(API_URL + "reset/password", values);
};

const authService = {
  //   register,
  auth,
  login,
  logout,
  reloadPage,
  permission,
  update_password,
  send_email_update_password,
  update_password_reset,
};

export default authService;
